import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, Star } from "lucide-react";
import { AvailabilityBadge } from "./AvailabilityBadge";
import { useLang } from "../context/LanguageContext";

export function CandidateCard({ c, index = 0, actions = null, testid }) {
  const { t } = useLang();
  return (
    <div
      data-testid={testid || `candidate-card-${c.id}`}
      className="gjt-card p-5 gjt-fade-up flex flex-col"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      {c.sponsored && (
        <span data-testid="sponsored-tag" className="self-start mb-3 inline-flex items-center gap-1 rounded-full bg-navy/5 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-navy">
          <Star className="h-3 w-3 fill-brand-orange text-brand-orange" /> {t("sponsored")}
        </span>
      )}
      <div className="flex items-start gap-4">
        <img
          src={c.photo_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(c.name)}&background=0A2472&color=fff`}
          alt={c.name}
          loading="lazy"
          className="h-14 w-14 rounded-full object-cover ring-2 ring-slate-100"
        />
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <h3 className="truncate font-display text-base font-bold text-navy">{c.name}</h3>
          </div>
          <p className="truncate text-sm font-medium text-brand-blue">{c.job_title || c.industry}</p>
          <p className="mt-0.5 flex items-center gap-1 text-xs text-slate-500">
            <MapPin className="h-3.5 w-3.5" /> {c.city}, {c.country}
          </p>
        </div>
      </div>

      <div className="mt-3"><AvailabilityBadge status={c.availability} /></div>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {(c.skills || []).slice(0, 4).map((s) => (
          <span key={s} className="rounded-full bg-brand-bluelight px-2.5 py-0.5 text-xs font-medium text-brand-blue">{s}</span>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
        <span className="flex items-center gap-1"><Briefcase className="h-3.5 w-3.5" /> {c.experience_years || 0}+ {t("years")}</span>
        <span className="font-semibold text-emerald-600">{c.completeness ?? 0}% {t("profile_strength")}</span>
      </div>

      <div className="mt-4 flex items-center gap-2">
        <Link
          to={`/u/${c.slug || c.id}`}
          data-testid={`view-candidate-${c.id}`}
          className="flex-1 rounded-xl border border-slate-200 px-3 py-2 text-center text-sm font-semibold text-navy transition-colors hover:bg-brand-bluelight"
        >
          {t("view_profile")}
        </Link>
        {actions}
      </div>
    </div>
  );
}
